import { render, staticRenderFns } from "./AvSelect.vue?vue&type=template&id=9fd44c40&lang=pug"
import script from "./AvSelect.vue?vue&type=script&lang=js"
export * from "./AvSelect.vue?vue&type=script&lang=js"
import style0 from "./AvSelect.vue?vue&type=style&index=0&id=9fd44c40&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconX: require('/app/components/anyvan/IconX.vue').default,IconAngle: require('/app/components/anyvan/IconAngle.vue').default,Icon: require('/app/components/vantone/Icon.vue').default})
